'use client';

import { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';
import { Link } from '@/i18n/routing';
import { useFavoritesStore } from '@/store/favorites-store';

export function FavoritesButton() {
  const getTotalFavorites = useFavoritesStore((state) => state.getTotalFavorites);
  const [totalItems, setTotalItems] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- standaard hydration-mount-detectie; er is geen ander moment om dit te weten dan in een effect
    setMounted(true);
    setTotalItems(getTotalFavorites());
  }, [getTotalFavorites]);

  useEffect(() => {
    if (!mounted) return;

    const unsubscribe = useFavoritesStore.subscribe(() => {
      setTotalItems(getTotalFavorites());
    });

    return unsubscribe;
  }, [mounted, getTotalFavorites]);

  return (
    <Link
      href="/favorieten"
      className="relative flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-gray-100"
      aria-label="Favorieten"
    >
      <Heart className="h-5 w-5 text-gray-600" />
      {mounted && totalItems > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-rose-600 text-xs font-medium text-white">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
    </Link>
  );
}
